import React from 'react';
import styles from '../Icon.module.css';
import { classNames } from '../../../utils';

export interface IconProps {
    className?: string;
}

const RepublicOfIrelandFlagIcon = ({ className }: IconProps) => {
    return (
        <div className={classNames(styles.icon, className ?? className)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
                <mask id="a">
                    <circle cx="256" cy="256" r="256" fill="#fff"/>
                </mask>
                <g mask="url(#a)">
                    <path fill="#eee" d="M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"/>
                    <path fill="#6da544" d="M0 0h167v512H0z"/>
                    <path fill="#ff9811" d="M345 0h167v512H345z"/>
                </g>
            </svg>
        </div>
    );
};

export default RepublicOfIrelandFlagIcon;
